import ComingSoon from "Component/ComingSoon";

const Admissions = () => {
  return <ComingSoon title="Soft school Admissions page" />;
};

export default Admissions;
